import {Injectable} from '@angular/core';
import {Toast} from '../dialog/alert/toastr/toast';
import {ToastrService} from 'ngx-toastr';
import {ToastType} from '../dialog/alert/toastr/toast-type.enum';
import {TranslateService} from "../shared/translate.service";


@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: Toast[] = [];

  constructor(private toastrService: ToastrService, private translateService: TranslateService) {
  }

  add(message: Toast) {
    this.messages.push(message);
    this.addToast(message);
  }

  clear() {
    this.messages.splice(0, this.messages.length);
  }

  private addToast(toast: Toast) {
    if (ToastType.ERROR === toast.type) {
      this.toastrService.error(toast.message, toast.title, undefined);
    }
    if (ToastType.INFO === toast.type) {
      this.toastrService.info(toast.message, toast.title, undefined);
    }
    if (ToastType.WARNING === toast.type) {
      this.toastrService.warning(toast.message, toast.title, undefined);
    }
    if (ToastType.SUCCESS === toast.type) {
      this.toastrService.success(toast.message, toast.title, undefined);
    }
  }

  public successMessage(titleKey: string, messageKey: string){
    this.message(titleKey, messageKey, ToastType.SUCCESS);
  }

  public errorMessage(titleKey: string, messageKey: string){
    this.message(titleKey, messageKey, ToastType.ERROR);
  }

  private message(titleKey: string, messageKey: string, type: ToastType) {
    this.add(
      new Toast(
        this.translateService.translate(titleKey),
        this.translateService.translate(messageKey),
        type));
  }
}
